import {SpinnerOverlay,SpinnerContainer} from "./spinner.styles"

export default function Spinner() {
  return (
    <SpinnerOverlay>
        <SpinnerContainer/>
    </SpinnerOverlay>
  )
}
